import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '..//baseRoute';

export type * from './queryParams';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}`;

export const URL = (tableQuery: TableQuery): RouteDefinition => `${baseRoute}?query=${encodeURIComponent(JSON.stringify(tableQuery))}`;
